export default __webpack_public_path__ + "static/icon3-b6f19e1bb252a267a675b7ed905ad990.png";